import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { defaultPaginationState } from './defaults';
import { PAGINATION_CURRENT, PAGINATION_TOTAL, PAGINATION_ITEMS_PER_PAGE, PAGINATION_TOTAL_ITEMS, PAGINATION_END_REACHED, PAGINATION_LINKS, PAGINATION_LINK_NEXT } from './constants';
import { get } from 'lodash';
export function setPagination(pagination) {
  if (pagination) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, PAGINATION_CURRENT, pagination.current_page), _defineProperty(_ref, PAGINATION_TOTAL, pagination.total_pages), _defineProperty(_ref, PAGINATION_ITEMS_PER_PAGE, pagination.per_page), _defineProperty(_ref, PAGINATION_TOTAL_ITEMS, pagination.total), _defineProperty(_ref, PAGINATION_END_REACHED, !pagination.total_pages || pagination.current_page >= pagination.total_pages), _defineProperty(_ref, PAGINATION_LINKS, _defineProperty({}, PAGINATION_LINK_NEXT, get(pagination, 'links.next'))), _ref;
  }

  return defaultPaginationState;
}